import * as React from 'react';

import './QuickLinks.scss';
import {
  SectionLearnMore,
  SectionQuickLinks,
  SectionResources,
  SectionSupport,
} from './Sections';

interface QuickLinksProps {
  showRebrandGuideAndAssetsLink?: boolean;
  showResources?: boolean;
  showSupport?: boolean;
}

export const QuickLinks: React.FC<QuickLinksProps> = ({
  showRebrandGuideAndAssetsLink = false,
  showResources = false,
  showSupport = true,
}) => (
  <section className="quick-links-container">
    {showSupport && <SectionSupport />}
    <SectionQuickLinks
      showRebrandGuideAndAssetsLink={showRebrandGuideAndAssetsLink}
    />
    <SectionLearnMore />
    {showResources && <SectionResources />}
  </section>
);
